export default {
      id: "ic_sun_white-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_sun_white-usage",
      toString: function () {
        return this.url;
      }
    }